import { useState } from "react";
import {
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import { Box, Grid, Typography } from "@mui/material";
import { CircularProgress } from "@material-ui/core";
import { icons } from "constants/icons";
import { Button } from "components/Buttons/Button";
import { ButtonColorScheme, ButtonType } from "types/ui";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

type Props = {
  isEnabled: boolean;
  setIsEnabled: any;
  modalLabel: string;
  title: string;
  text: string;
  subText?: string;
  successMessage?: string;
  content?: any;
  onConfirm: any;
};

export const ReusableModal = ({
  isEnabled,
  setIsEnabled,
  modalLabel,
  content,
  title,
  text,
  subText,
  onConfirm,
  successMessage,
}: Props) => {
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [successMessageText, setSuccessMessageText] = useState<string>("");

  const handleConfirm = async () => {
    setLoading(true);
    const response = await onConfirm();
    const hasError = response.error;
    setLoading(false);

    if (!hasError) {
      if (successMessage) {
        setSuccessMessageText(successMessage);
      }
      setTimeout(() => {
        setIsEnabled(false);
        setError("");
        setSuccessMessageText("");
      }, 2500);
    } else {
      setError(hasError);
    }
  };

  const handleCancel = () => {
    setIsEnabled(false);
    setError("");
    setSuccessMessageText("");
  };

  return (
    <StyledModal
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box sx={managementModalStyle}>
        <Grid container mt={1} mb={1} sx={{ width: "100%" }}>
          <Grid item xs={11} sx={{ fontWeight: "800", fontSize: 16 }}>
            {modalLabel}
          </Grid>
          <Grid item xs={1}>
            <img
              aria-hidden="true"
              src={icons.modalClose}
              alt="close"
              style={{ cursor: "pointer" }}
              onClick={() => {
                setIsEnabled(false);
                setError("");
                setSuccessMessageText("");
              }}
            />
          </Grid>

          <Grid>
            <Grid>
              <Typography
                sx={{ fontWeight: "900", fontSize: 14, paddingBottom: 1 }}
              >
                {title}
              </Typography>
              <Typography>{text}</Typography>
              <Typography>{subText}</Typography>

              {error && (
                <Typography sx={{ mt: 3 }} color={"error"}>
                  {error}
                </Typography>
              )}
              {successMessageText && (
                <Grid className="flex justify-center align-center mt-3">
                  <CheckCircleIcon
                    style={{ color: "green", fontSize: "50px" }}
                  />
                  <Typography sx={{ mt: 1.5, ml: 1, color: "green" }}>
                    {successMessageText}
                  </Typography>
                </Grid>
              )}
              {content}
            </Grid>

            {!successMessageText && (
              <Grid
                sx={{
                  mt: 2,
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <Button onClick={handleCancel}>Cancel</Button>
                {loading ? (
                  <CircularProgress />
                ) : (
                  <Button
                    onClick={handleConfirm}
                    type={ButtonType.normal}
                    colorScheme={ButtonColorScheme.gradient}
                  >
                    Confirm
                  </Button>
                )}
              </Grid>
            )}
          </Grid>
        </Grid>
      </Box>
    </StyledModal>
  );
};
